// extracted by css-extract-rspack-plugin
export default {"cls1":"SelectionCitation-cls1_s1g","cls2":"SelectionCitation-cls2_2rN SelectionCitation-cls1_s1g"};